import React, { useState, useRef, useEffect } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { ymd } from "./dateRanges";

// "YYYY-MM-DD" -> Date (local), and -> "DD.MM.YYYY" for display.
function parseYmd(s) {
  if (!s) return undefined;
  const [y, m, d] = s.split("-").map(Number);
  if (!y || !m || !d) return undefined;
  return new Date(y, m - 1, d);
}
function fmtEt(s) {
  if (!s) return "";
  const [y, m, d] = s.split("-");
  return `${d}.${m}.${y}`;
}

/**
 * Single calendar range picker: click = start, next click = end (no closing in
 * between). Controlled via startDate/endDate ("YYYY-MM-DD") + onChange(s, e).
 */
export default function DateRangeField({ startDate, endDate, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function onDown(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  const from = parseYmd(startDate);
  const to = parseYmd(endDate);
  const range = from ? { from, to } : undefined;

  function handleSelect(r) {
    const f = r && r.from;
    const t = r && r.to;
    onChange(f ? ymd(f) : "", t ? ymd(t) : "");
    if (f && t) setOpen(false); // both ends picked -> close
  }

  const label =
    startDate || endDate
      ? `${fmtEt(startDate) || "…"} – ${fmtEt(endDate) || "…"}`
      : "Vali kuupäevad";

  return (
    <div ref={ref} style={styles.wrap}>
      <button type="button" style={styles.field} onClick={() => setOpen((o) => !o)}>
        <span>📅 {label}</span>
        <span style={styles.caret}>{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <div style={styles.calendar}>
          <DayPicker
            mode="range"
            selected={range}
            onSelect={handleSelect}
            defaultMonth={from || new Date()}
            weekStartsOn={1}
            showOutsideDays
          />
        </div>
      )}
    </div>
  );
}

const styles = {
  wrap: { position: "relative" },
  field: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
    borderRadius: "10px",
    border: "1px solid #8CA5E6",
    padding: "10px 12px",
    background: "#fff",
    color: "#0D1F4D",
    fontSize: "14px",
    fontFamily: "'DM Sans', sans-serif",
    cursor: "pointer",
    boxSizing: "border-box",
  },
  caret: { color: "#8CA5E6", fontSize: "11px" },
  calendar: {
    marginTop: "8px",
    background: "white",
    borderRadius: "12px",
    border: "1px solid #E6ECF8",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    display: "flex",
    justifyContent: "center",
  },
};
